import { Link } from '@inertiajs/react'
import { ArrowLeft } from 'lucide-react'
import type { ReactNode } from 'react'
import { Button } from '@/components/ui/button'
import { useBasePath } from '@/lib/paths'
import { cn } from '@/lib/utils'
import type { WizardStepKey } from '@/types'

const PREVIOUS_STEP: Partial<Record<WizardStepKey, WizardStepKey>> = {
  state: 'residency',
  entity_type: 'state',
  name: 'entity_type',
  company: 'name',
  people: 'company',
  structure: 'people',
  tax_setup: 'structure',
  review: 'tax_setup',
  documents: 'review',
  signature: 'documents',
  submission: 'signature',
}

type WizardActionsProps = {
  currentStep: WizardStepKey
  formationId?: string
  disabled?: boolean
  children?: ReactNode
  className?: string
}

export function WizardActions({ currentStep, formationId, disabled = false, children, className }: WizardActionsProps) {
  const basePath = useBasePath()
  const previousStep = PREVIOUS_STEP[currentStep]
  const previousHref = previousStep && formationId
    ? `${basePath}/formations/${formationId}/wizard/${previousStep}/edit`
    : `${basePath}/businesses`

  return (
    <div className={cn('flex flex-wrap items-center gap-2 [&_[data-slot=button]]:min-h-11', className ?? 'mt-8')}>
      {disabled ? (
        <Button type="button" variant="outline" disabled>
          <ArrowLeft className="size-4" />
          Back
        </Button>
      ) : (
        <Button asChild variant="outline">
          <Link href={previousHref}>
            <ArrowLeft className="size-4" />
            Back
          </Link>
        </Button>
      )}
      {children}
    </div>
  )
}
